"use client";

/* -----------------Helpers--------------- */
import { cn } from "@/lib/utils";
import type { ImageDetails } from "@/types";
/* -----------------Globals--------------- */
import Image from "next/image";
import { ActionButton } from "./ActionButton";
import type { IconName } from "./Icon";
import WebsiteUrlLink from "./WebsiteUrlLink";
import { CardHeader } from "./ui/card";
import { Card } from "./ui/card";

export type CustomerCardProps = {
	name: string;
	logo: ImageDetails;
	websiteUrl?: string;
	storyUrl?: string;
	storyExternal?: boolean;
	action?: {
		name: string;
		iconRight?: string;
	};
	className?: string;
	containerClassName?: string;
};

const CustomerCard = ({
	name,
	logo,
	websiteUrl,
	storyUrl,
	storyExternal,
	action,
	className,
	containerClassName,
}: CustomerCardProps) => {
	return (
		<Card
			className={cn(
				"relative flex h-48 w-full items-center justify-center border-none shadow-none",
				{ group: websiteUrl },
				containerClassName,
			)}
		>
			<span className="sr-only">{name}</span>
			{websiteUrl && <WebsiteUrlLink url={websiteUrl} />}
			<div className="-inset-x-12 absolute top-0 h-px bg-neutral-200" />
			<div className="-inset-x-12 absolute bottom-0 h-px bg-neutral-200" />
			<div className="-inset-y-12 absolute left-0 w-px bg-neutral-200" />
			<div className="-inset-y-12 absolute right-0 w-px bg-neutral-200" />

			<CardHeader
				className={cn("flex h-24 items-center justify-center", className)}
			>
				<Image
					src={logo.src}
					alt={logo.alt}
					width={logo?.width || 256}
					height={logo?.height || 256}
					className="h-full object-contain"
				/>
			</CardHeader>
			{storyUrl && (
				<ActionButton
					name={action?.name || "Read more"}
					href={storyUrl}
					iconRight={(action?.iconRight as IconName) || "ArrowRight"}
					variant="link"
					className="absolute right-4 bottom-2"
					external={storyExternal}
				/>
			)}
		</Card>
	);
};

export default CustomerCard;
